import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-import-products',
  templateUrl: './import-products.component.html',
  styleUrls: ['./import-products.component.scss']
})
export class ImportProductsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
